import { computed, ref } from '@vue/composition-api';
import useList from '../_basic/list';
import useItem from '../_basic/item';
import gqlItem from './item.graphql';
import gqlList from './list.graphql';
import groups from './groups';
import provider from '@/api/apollo-client';

const user = new useItem(gqlItem);
const users = new useList(gqlList);

export default function(filters) {
  const showFields = ref(['login', 'enabled', 'mEmail', 'mPhone', 'type']);
  return {
    user: {
      ...user,
      createUsersToObject: function(userId, objectId) {
        return provider.mutate({
          mutation: gqlItem.createUsersToObject,
          variables: {
            input: {
              usersToObject: {
                userId,
                objectId
              }
            }
          }
        });
      },
      deleteUsersToObject: function(userId, objectId) {
        return provider.mutate({
          mutation: gqlItem.deleteUsersToObject,
          variables: {
            input: {
              userId,
              objectId
            }
          }
        });
      }
    },
    users: {
      ...users,
      updateUsers: function(data) {
        return provider.mutate({
          mutation: gqlList.updateUsers,
          variables: {
            input: {
              mnPatch: data
            }
          }
        });
      },
      visibleFields: computed({
        get: () => {
          const sorted = showFields.value.map(i => {
            return users.visibleFields.value.find(e => e === i);
          });
          if (users.visibleFields.value.length) {
            return sorted;
          }
          return [];
        },
        set: arr => {
          showFields.value = arr;
          users.visibleFields.value = arr;
        }
      }),
      fields: computed(() => {
        const sorted = showFields.value.map(i => {
          return users.fields.value.find(e => e.field === i);
        });
        if (users.fields.value.length) {
          return sorted;
        }
        return [];
      })
    },
    ...groups
  };
}
